import Accordion from "@/common/components/Accordion";
import { BookMarked } from "lucide-react";

export default function AccordionScrapRulesOverview() {
  return (
    <Accordion
      name="scrapRulesOverview"
      head={
        <div className="flex items-center gap-1">
          <BookMarked strokeWidth={1.5} />
          <p className="text-base">Como funciona a regra para desfazimento</p>
        </div>
      }
      body={
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">
            <p className="text-sm">
              <b className="font-bold">Regras para Desfazimento</b>
              {" "}permite que você, gestor de frotas, crie regras automatizadas para identificar equipamentos que estão prontos para serem desmobilizados, com base em critérios operacionais estratégicos.
            </p>
            <p className="text-sm">Com essa ferramenta, você poderá:</p>
          </div>
          <div className="flex flex-col gap-2.5">
            <p className="text-sm">
              <b className="font-bold">Agrupar equipamentos com opções personalizados:</b> <br />
              Odômetro mínimo/máximo atingido, Localização em filiais específicas, Categorias e fabricantes definidos e muito mais.
            </p>
            <p className="text-sm">
              <b className="font-bold">Definir as condições de desfazimento:</b> <br />
              Configure os gatilhos que indicarão que o equipamento está elegível para desfazimento, de acordo com sua política interna como quilometragem/hora uso máximo ou tempo de uso máximo.
            </p>
            <p className="text-sm">
              <b className="font-bold">Receber alertas automáticos:</b> <br />
              Ao atenderem os critérios definidos, os equipamentos serão destacados em: Notificações por e-mail e Dashboard/Home do sistema, facilitando o acompanhamento direto na sua rotina
            </p>
          </div>
        </div>
      }
    />
  )
}
